/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Messages
import messages from './messages/ReviewsCard_messages';

// Components
import IconRating from '../common/IconRating';
import Button from '../../components/Button';

const propTypes = {
  review: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  canSendMessage: PropTypes.bool,
  startChat: PropTypes.func,
};

class ReviewsCard extends PureComponent {
  constructor(props) {
    super(props);
    this.reviewTypes = ['overall', 'price', 'quality', 'thumbs'];
  }

  _startChat = () => {
    this.props.startChat({ reviewId: this.props.review.id });
  };

  render() {
    const { intl, review, canSendMessage } = this.props;
    if (!review) return null;

    const appPath = '/selvitys'; // TODO: Temporary
    const isCompanyReview = !review.company;

    const reviewDescriptionMapping = {
      overall: intl.formatMessage(messages.ratingLabelOverall),
      price: intl.formatMessage(messages.ratingLabelPrice),
      quality: intl.formatMessage(messages.ratingLabelQuality),
      thumbs: intl.formatMessage(messages.ratingLabelThumbs),
    };

    return (
      <Container>
        <Reviewer>
          {isCompanyReview &&
            (review.user_id ? (
              <Link to={`${appPath}/user/${review.user_id}/reviews`}>
                {review.name}
              </Link>
            ) : (
              <FormattedMessage
                {...messages.serviceUser}
                info="Service's <servicename> user"
                values={{ serviceName: review.partner }}
              />
            ))}
          {!isCompanyReview && (
            <Link
              to={
                `${appPath}/${review.company.country}` +
                `/${review.company.identifier}`
              }
            >
              {review.company.name}
            </Link>
          )}
        </Reviewer>

        {this.reviewTypes.map(type => (
          <RatingRow key={type}>
            <RatingType>{reviewDescriptionMapping[type]}</RatingType>
            <IconRating
              themeName={type}
              readonly
              reviewValue={review[type]}
            />
          </RatingRow>
        ))}

        {canSendMessage && (
          <ChatLink>
            <MessageButton onClick={this._startChat}>
              <FormattedMessage
                {...messages.sendMessage}
                info="Send message to user"
              />
            </MessageButton>
          </ChatLink>
        )}
      </Container>
    );
  }
}

ReviewsCard.propTypes = propTypes;

const ChatLink = styled.div`
  margin: 12px;
`;

const Container = styled.div`
  border: 3px solid ${props => props.theme['grey-normal']};
  border-radius: 6px;
  box-sizing: border-box;
  padding: 3px;
  text-align: center;
  width: 100%;
`;

const MessageButton = styled(Button)`
  width: 100%;
`;

const RatingRow = styled.div`
  border-bottom: 1px solid ${props => props.theme['grey-light']};
  padding: 12px 0;

  &:last-child {
    border-bottom: none;
  }
`;

const RatingType = styled.h2`
  margin: 0;
`;

const Reviewer = styled.div`
  align-items: center;
  background: ${props => props.theme['grey-xlight']};
  border-bottom: 1px solid ${props => props.theme['grey-light']};
  display: flex;
  font-weight: bold;
  justify-content: center;
  padding: 24px 0;
`;

export default injectIntl(ReviewsCard);
